import SectionContainer from '@common/components/SectionContainer';
import { Routes } from '@common/constants';
import { useTranslations } from '@lang';
import { FC, useCallback, useMemo } from 'react';
import { useRouter } from 'shared-routing';
import { Category } from 'shared-types/Common';
import { SpaCategoryListTemplate } from 'voyager';

type CategoriesV2Props = {
  categories: Category[];
};

export const CategoriesV2: FC<CategoriesV2Props> = ({ categories }) => {
  const router = useRouter();
  const { t } = useTranslations();

  const items = useMemo(
    () =>
      (categories ?? [])
        .filter((category) => !category.isPrivate)
        .map((category) => ({
          id: String(category.id),
          name: category.name,
          imageUrl: category.image?.url ?? undefined,
          price: null,
        })),
    [categories]
  );

  const handleSelectCategory = useCallback(
    (id: string) => {
      router.push({ pathname: Routes.CATEGORY_DETAIL, query: { id } });
    },
    [router]
  );

  return (
    <SectionContainer>
      <SpaCategoryListTemplate
        categories={items}
        onSelectCategory={handleSelectCategory}
        titleLabel={t('categoriesListing.collectionsTitle')}
        subtitleLabel={t('categoriesListing.collectionsSubtitle')}
        noResultsLabel={t('categoriesListing.noCollections')}
        noImageLabel={t('spa.noImage')}
        columns={2}
        mobileColumns={2}
        titleAlignment="center"
      />
    </SectionContainer>
  );
};
